// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 373) return "static/chunks/373-63e7bb2c2335e2de.js";
	if (chunkId === 56) return "static/chunks/56-1a80bbb0469c5614.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"130":"547c182a5d7dea1b","492":"2b6051bbb8b0b647","724":"c570cb2544e1eb40"}[chunkId] + ".js";
};